import React, { useState } from 'react';
import { Stack, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useInterventionCreation } from '../../context/interventionCreationContext';
import ImportKindToggle, { ImportKind } from './ImportKindToggle';
import { buildCopyPasteFormData, buildCopyPasteImportUrl } from './pdsImport';
import { PdsImportState } from './usePdsImport';

type CopyPasteTabProps = {
  kind: ImportKind;
  onKindChange: (kind: ImportKind) => void;
  importState: PdsImportState;
};

export default function CopyPasteTab({ kind, onKindChange, importState }: CopyPasteTabProps) {
  const { t } = useTranslation();
  const { state } = useInterventionCreation();

  const [pastedText, setPastedText] = useState('');

  const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
    const clipboardText = event.clipboardData.getData('text');
    setPastedText(clipboardText);

    if (!clipboardText.trim() || state.clientId === null) {
      return;
    }

    importState.importPds({
      url: buildCopyPasteImportUrl(
        kind,
        state.clientId,
        Intl.DateTimeFormat().resolvedOptions().timeZone
      ),
      body: buildCopyPasteFormData(clipboardText)
    });
  };

  return (
    <Stack spacing={2}>
      <ImportKindToggle
        value={kind}
        onChange={onKindChange}
        labelKey="interventionCreation.addServicePoints.kind"
      />

      <Stack spacing={1}>
        <TextField
          id="pds-identifiers"
          multiline
          rows={5}
          fullWidth
          value={pastedText}
          onChange={(event) => setPastedText(event.target.value)}
          onPaste={handlePaste}
          placeholder={t('interventionCreation.addServicePoints.copyPaste.placeholder')}
        />
      </Stack>
    </Stack>
  );
}
